import React from "react";
// import CustomCss from "../BuilderComponents/CustomCss";
import Input from "../FormComponents/Input";

const EditProgressBar = ({ editElementData, setEditElementData }) => {
  const handleCustomCss = (e) => {
    const { name, value } = e.target;
    setEditElementData({ ...editElementData, [name]: value });
  };
  return (
    <>
      <div className="builder_form">
        <Input
          label="Progress Bar Width"
          type="number"
          name="width"
          value={editElementData?.width}
          onChange={handleCustomCss}
        />
        {/* <CustomCss
          value={{
            custom_css: editElementData.custom_css || "",
            custom_id: editElementData.custom_id || "",
            custom_classname: editElementData.custom_classname || ""
          }}
          onChange={handleCustomCss}
        /> */}
      </div>
    </>
  );
};

export default EditProgressBar;
